import "../../assets/scss/create-target.scss";
import "../../assets/scss/reports/cashbook.scss";

import { useAuth } from "../../hooks/useAuth";
import { useQuery } from "react-query";
import {
  calculateIncentive,
  fetchActionsUtil,
  formatDate,
  formatDateTime,
  paginationOptions,
} from "../../utils/helpers";

import currency from "currency.js";
import TableComponent from "../TableComponent";
import { Modal, Nav, Badge } from "react-bootstrap";
import { useState } from "react";
import ReactPaginate from "react-paginate";
import {
  SummaryChartIconDown,
  SummaryChartIconUp,
  SummaryCloseIcon,
} from "../Icons";
import { useCurrencies } from "../../utils/hooks";

function BoolBadge({ value, trueLabel = "Yes", falseLabel = "No" }) {
  return (
    <Badge bg={value ? "danger" : "success"}>
      {value ? trueLabel : falseLabel}
    </Badge>
  );
}
function BoolBadgeReversed({ value, trueLabel = "Yes", falseLabel = "No" }) {
  return (
    <Badge bg={value ? "success" : "danger"}>
      {value ? trueLabel : falseLabel}
    </Badge>
  );
}

const TargetIncentiveEarningHistory = ({
  show,
  setShow,
  userId,
  targetOccurrenceId,
  user,
  title,
  target,
}) => {
  const { backendUrl } = useAuth();
  const [activeTab, setActiveTab] = useState("sales"); // "sales" | "earning"
  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 10,
    userId,
    targetOccurrenceId,
  });

  const [btnSummryActive, setBtnSummaryActive] = useState(false);
  const [showMoreSummary, setShowMoreSummary] = useState(true);

  console.log("this is the target: ", target);
  const { prevailingCurrencySymbol } = useCurrencies();

  const {
    data: {
      sales = [],
      incentiveEarning = [],
      countIncentive = 0,
      countSales = 0,
    } = {},
  } = useQuery(
    ["TARGET_SALES_EARNING_HISTORY", queryParams],
    () =>
      fetchActionsUtil(
        `${backendUrl}/api/company/get-target-sales-earn-history?userId=${userId}&targetOccurrenceId=${targetOccurrenceId}&page=${
          queryParams.page
        }&limit=${queryParams.limit}`,
      ),
    {
      enabled: true,
      keepPreviousData: true,
      onSuccess: ({ sales = [] }) => {
        if (sales?.length) {
          console.log("thi is the sales: ", sales);
          console.log(calculateIncentive(target, sales));
        }
      },
    },
  );

  const isSalesTab = activeTab === "sales";
  const activeData = isSalesTab ? sales : incentiveEarning;
  const activeCount = isSalesTab ? countSales : countIncentive;

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    setQueryParams((prev) => ({ ...prev, page: 1 }));
  };

  const handleSearchQueryChange = (e) => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
      page: 1,
    });
  };

  // ---------- SALES TABLE ----------
  const salesTableHead = () => (
    <thead className="position-sticky top-0">
      <tr>
        <th>Sale Trans ID</th>
        <th>Sale Date</th>
        <th>Qty</th>
        <th>Sub Total</th>
        <th>Amount Sold</th>
        <th>Reversed</th>
      </tr>
    </thead>
  );

  const salesTableData = (el) => (
    <>
      <td>{el?.salesTransID ?? ""}</td>
      <td>{el?.saleDate ? formatDate(el.saleDate) : ""}</td>
      <td>{el?.qty ?? ""}</td>
      <td>
        {currency(el?.subTotal ?? 0).format({ symbol: "", separator: "," })}
      </td>
      <td>{el?.metricAmount ?? ""}</td>
      <td>
        <BoolBadge
          value={el?.reversed}
          trueLabel="Reversed"
          falseLabel="Active"
        />
      </td>
    </>
  );

  // ---------- EARNINGS TABLE ----------
  const earningTableHead = () => (
    <thead className="position-sticky top-0">
      <tr>
        <th>Payment Trans ID</th>
        <th>Sale Date</th>
        <th>Payment Date</th>
        <th>Qty</th>
        <th>Sub Total</th>
        <th>Amount Paid</th>
        <th>Payment Fraction</th>
        <th>Reversed</th>
      </tr>
    </thead>
  );

  const earningTableData = (el) => (
    <>
      <td>{el?.paymentTransId ?? ""}</td>
      <td>{el?.saleDate ? formatDate(new Date(el?.saleDate)) : ""}</td>
      <td>{el?.paymentDate ? formatDate(new Date(el?.paymentDate)) : ""}</td>
      <td>{el?.qty ?? ""}</td>
      <td>
        {currency(el?.subTotal ?? 0).format({ symbol: "", separator: "," })}
      </td>
      <td>
        <b>
          {currency(el?.amountPaid ?? 0).format({ symbol: "", separator: "," })}
        </b>
      </td>
      <td>
        {el?.paymentFraction != null
          ? `${(Number(el.paymentFraction) * 100).toFixed(0)}%`
          : ""}
      </td>

      <td>
        <BoolBadge
          value={el?.reversed}
          trueLabel="Reversed"
          falseLabel="Active"
        />
      </td>
    </>
  );
  const close = () => {
    setShowMoreSummary(true);
    setBtnSummaryActive(false);
  };
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      animation={false}
      enforceFocus={false}
      centered
      size="lg"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>{title || "Sales / Incentive Earning History"}</h6>
          <p className={"subtitle"}>
            View the sales and incentive earning history for {user}
          </p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={"container"}>
          <Nav
            variant="tabs"
            activeKey={activeTab}
            onSelect={(k) => handleTabChange(k)}
            className="mb-3"
          >
            <Nav.Item>
              <Nav.Link eventKey="sales">Sales ({countSales})</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="earning">
                Incentive Earning ({countIncentive})
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <div className="px-md-4">
            <TableComponent
              responsive
              borderless
              striped
              tableHeadsFunction={
                isSalesTab ? salesTableHead : earningTableHead
              }
              mainDataArray={activeData}
              className="product-table table-fixed"
              tableDataRowFunction={
                isSalesTab ? salesTableData : earningTableData
              }
            />
          </div>

          <div className="d-flex justify-content-between px-3 align-items-center pagination">
            <div className="pagination_left">
              <p className="m-0 p-0">Show</p>
              <select
                value={queryParams.limit}
                name="limit"
                className="form-select"
                onChange={handleSearchQueryChange}
              >
                <option value="10">10 rows</option>
                <option value="20">20 rows</option>
                <option value="30">30 rows</option>
                <option value="40">40 rows</option>
                <option value="50">50 rows</option>
                <option value="100">100 rows</option>
              </select>
            </div>

            <ReactPaginate
              {...paginationOptions}
              pageCount={Math.ceil(activeCount / queryParams.limit)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={0}
              onPageChange={({ selected }) => {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                setQueryParams({
                  ...queryParams,
                  page: selected + 1,
                });
              }}
              forcePage={queryParams.page - 1}
            />
          </div>

          <div
            className={
              btnSummryActive
                ? `summaryNew border-top open`
                : `summaryNew border-top`
            }
          >
            {/*  For Current Period  */}
            <div className="mb-3 row mt-3">
              <div className="gridCont d-flex gap-3">
                <div
                  className="gridChild gridChildBorderLeftBlue "
                  style={{ flex: 1 }}
                >
                  <div className="gridChildLeft">
                    <p className="gridChld1">
                      {currency(target?.payout?.baseIncentiveAmount ?? 0, {
                        symbol: prevailingCurrencySymbol,
                      }).format()}
                    </p>
                    <p className="gridChld2">Incentive Amount (Met)</p>
                  </div>

                  {/* <div className="gridChildRight">
                    <SummaryChartIconUp />
                    <p>5%</p>
                  </div> */}
                </div>

                <div
                  className="gridChild gridChildBorderLeftOrange 
"
                  style={{ flex: 1 }}
                >
                  <div className="gridChildLeft">
                    <p className="gridChld1">
                      {currency(target?.payout?.exceededIncentiveAmount ?? 0, {
                        symbol: prevailingCurrencySymbol,
                      }).format()}
                    </p>
                    <p className="gridChld2">Incentive Amount (Exceeded)</p>
                  </div>

                  {/* <div className="gridChildRight">
                    <SummaryChartIconUp />
                    <p>5%</p>
                  </div> */}
                </div>

                <div
                  className="gridChild gridChildBorderLeftBrown "
                  style={{ flex: 1 }}
                >
                  <div className="gridChildLeft">
                    <p className="gridChld1">
                      {currency(target?.payout?.notMetIncentiveAmount ?? 0, {
                        symbol: prevailingCurrencySymbol,
                      }).format()}
                    </p>
                    <p className="gridChld2">Incentive Amount (Not Met)</p>
                  </div>

                  {/* <div className="gridChildRight">
                    <SummaryChartIconDown />
                    <p>5%</p>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TargetIncentiveEarningHistory;
